document.addEventListener('DOMContentLoaded', () => {
  const accordionContainer = document.querySelector('.app-accordion__container');
  if (!accordionContainer) return;

  // Get all accordion items
  const accordionItems = accordionContainer.querySelectorAll('.navigation-mobile-accordion__item');

  accordionItems.forEach(item => {
    const toggle = item.querySelector('.navigation-mobile-accordion__toggle');
    if (!toggle) return;

    const submenu = item.querySelector('.navigation-mobile-accordion__submenu');
    if (!submenu) return;

    // Set initial max-height based on whether it's default open
    if (item.classList.contains('submenu-active')) {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isActive = item.classList.contains('submenu-active');
      
      // Close all siblings at the same level
      const parentList = item.parentElement;
      const siblings = Array.from(parentList.children).filter(child => 
        child !== item && child.classList.contains('submenu-active')
      );
      
      siblings.forEach(sibling => {
        const siblingSubmenu = sibling.querySelector('.navigation-mobile-accordion__submenu');
        if (siblingSubmenu) {
          siblingSubmenu.style.maxHeight = '0';
          sibling.classList.remove('submenu-active');
          const siblingToggle = sibling.querySelector('.navigation-mobile-accordion__toggle');
          if (siblingToggle) {
            siblingToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Toggle current item
      if (isActive) {
        submenu.style.maxHeight = '0';
        item.classList.remove('submenu-active');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        item.classList.add('submenu-active');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    // Handle nested accordions (second level)
    const nestedItems = submenu.querySelectorAll('.navigation-mobile-accordion__submenu-item.has-submenu');
    nestedItems.forEach(nestedItem => {
      const nestedToggle = nestedItem.querySelector('.navigation-mobile-accordion__toggle');
      const nestedSubmenu = nestedItem.querySelector('.navigation-mobile-accordion__submenu');
      
      if (!nestedToggle || !nestedSubmenu) return;

      nestedToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isNestedActive = nestedItem.classList.contains('submenu-active');
        
        // Close sibling nested items
        const nestedParent = nestedItem.parentElement;
        const nestedSiblings = Array.from(nestedParent.children).filter(child => 
          child !== nestedItem && child.classList.contains('submenu-active')
        );
        
        nestedSiblings.forEach(sibling => {
          const siblingSubmenu = sibling.querySelector('.navigation-mobile-accordion__submenu');
          if (siblingSubmenu) {
            siblingSubmenu.style.maxHeight = '0';
            sibling.classList.remove('submenu-active');
            const siblingToggle = sibling.querySelector('.navigation-mobile-accordion__toggle');
            if (siblingToggle) {
              siblingToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // Toggle nested item
        if (isNestedActive) {
          nestedSubmenu.style.maxHeight = '0';
          nestedItem.classList.remove('submenu-active');
          nestedToggle.setAttribute('aria-expanded', 'false');
        } else {
          nestedSubmenu.style.maxHeight = nestedSubmenu.scrollHeight + 'px';
          nestedItem.classList.add('submenu-active');
          nestedToggle.setAttribute('aria-expanded', 'true');
        }

        // Recalculate parent submenu height
        setTimeout(() => {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        }, 10);
      });
    });
  });

  // Keyboard accessibility
  accordionContainer.addEventListener('keydown', (e) => {
    if (e.target.classList.contains('navigation-mobile-accordion__toggle')) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.target.click();
      }
    }
  });
});